import VerificationIcon from "../assets/img/complete-verification-icon.svg";
import { useState, useEffect } from "react";
import profileBg from "../assets/img/profileBg.png";
import closeGrayIcon from "../assets/img/close-gray-icon.svg";
import settingsIcon from "../assets/img/settings-icon.svg";
import moveIcon from "../assets/img/move-icon1.svg";
import PlusRoundIcon from "../assets/img/plus-round-icon.svg";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { connect } from "react-redux";
import OwlCarousel from "react-owl-carousel";
import { DeleteOutline } from "@mui/icons-material";
import { fetchGraphMethod } from "../../../../../../services/httpService";
import { addAlbumQuery, addTagQuery, getAllAlbumsTags } from "./AlbumTagsQuery";
import {getUserInfo} from "../../../../../../services/authService";
import toastr from "toastr";
import { allAlbumTagsListStart } from "../../../../../../redux/athlete/dashboard/editUserProfile/allAlbumTags";
import { imageDownloadUrl, websiteDefaultUrl } from "../../../../../../config";
import { postDateFormat } from "../../../../../../utils/dateTimeFormatter";
import {
  saveMediaQuery,
  savePostQuery,
  updatePostsQuery,
} from "../../homepage/posts/PostsQuery";
import { savePostStart } from "../../../../../../redux/athlete/dashboard/homepage/savePost";
import usePrevious from "../../../../../../utils/usePrevious";
import BackdropLoader from "../../../../../common/Loader";
import { Switch } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import {
  deleteAlbumStart,
  deleteTagStart,
} from "../../../../../../redux/athlete/dashboard/editUserProfile/photo-video/deleteAlbumTag";
import swal from "sweetalert";
import { getAllVideoPhotoInfoQuery } from "./VideoPhotoQuery";
import { allVideoPhotoListStart } from "../../../../../../redux/athlete/dashboard/editUserProfile/photo-video/getVideoPhotoInfo";
import { Tooltip } from "@mui/material";
import VerificationModal from "../VerificationModal";
import thumbnail from '../../../../../../assets/img/video-to-link-thumbnail.jpg'
import {VideoPop} from "../../../../landingPage/common/videoPopup";
import { getThumbnail, typeConvert } from '../../../../../common/thumbnail'
import {vidCountIncre} from "../../../../../common/userViewCount";
import {Link} from "react-router-dom";
import history from "../../../../../../services/history";
import {getAthleteSysID} from "../../../../../common/getProfileURLData";

const useStyles = makeStyles((theme) => ({
  toggle: {
    "& .Mui-checked": {
      color: "#1cb79e",
    },
    "& .MuiSwitch-track": {
      backgroundColor: "#8ddbce",
    },
  },
}));

const SubHeader = (props) => {
  const { onSideMenuClick } = props;
  const [showVerificationModalState, setShowVerificationModalState] =
      useState(false);

  const showVerificationModal = () => {
    setShowVerificationModalState(!showVerificationModalState);
  };
  return (
    <div className="subHeader">
      <div className="menu">
        <button onClick={onSideMenuClick}>
          <span></span> Edit Profile
        </button>
      </div>
      {JSON.parse(localStorage.getItem("user")).verifiedUserStatus === 1 ? (
        <div className="profile-verified-text">
          <span className="verifiedIcon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="26.418"
              height="26.403"
              viewBox="0 0 26.418 26.403"
            >
              <defs>
                <style></style>
              </defs>
              <path
                className="a"
                d="M-4229.021-6663.778a1.151,1.151,0,0,1-.986-.543,1.174,1.174,0,0,0-.993-.543,1.174,1.174,0,0,0-.993.543,1.151,1.151,0,0,1-.986.543,1.169,1.169,0,0,1-1.152-.9v-.005a1.179,1.179,0,0,0-1.149-.9,1.16,1.16,0,0,0-.728.256,1.169,1.169,0,0,1-.729.259,1.2,1.2,0,0,1-.883-.392,1.158,1.158,0,0,1-.3-.9l0-.013a1.161,1.161,0,0,0-.3-.9,1.184,1.184,0,0,0-.87-.387,1.181,1.181,0,0,0-.395.068h-.005a1.189,1.189,0,0,1-.4.07,1.175,1.175,0,0,1-.984-.544,1.155,1.155,0,0,1-.084-1.116l.01-.021a1.174,1.174,0,0,0-.088-1.121,1.175,1.175,0,0,0-.989-.538h-.033a1.163,1.163,0,0,1-1.08-.708,1.164,1.164,0,0,1,.219-1.274l.019-.019a1.171,1.171,0,0,0,.28-1.09,1.176,1.176,0,0,0-.769-.831l-.02,0a1.164,1.164,0,0,1-.8-1.02,1.164,1.164,0,0,1,.621-1.138l.02-.01a1.174,1.174,0,0,0,.621-.943,1.172,1.172,0,0,0-.456-1.031l-.02-.017a1.161,1.161,0,0,1-.425-1.223,1.164,1.164,0,0,1,.957-.875l.017,0a1.174,1.174,0,0,0,.894-.688,1.172,1.172,0,0,0-.1-1.125l-.013-.021a1.159,1.159,0,0,1-.058-1.2,1.173,1.173,0,0,1,1.03-.625,1.229,1.229,0,0,1,.215.019h.008a1.234,1.234,0,0,0,.21.019,1.166,1.166,0,0,0,.928-.459,1.169,1.169,0,0,0,.207-1.017l0-.017a1.148,1.148,0,0,1,.2-1.012,1.2,1.2,0,0,1,.938-.467,1.169,1.169,0,0,1,.572.151,1.16,1.16,0,0,0,.571.15,1.186,1.186,0,0,0,1.177-1.092v-.01a1.176,1.176,0,0,1,1.184-1.092,1.158,1.158,0,0,1,.866.39,1.159,1.159,0,0,0,.871.39,1.18,1.18,0,0,0,1.086-.715,1.162,1.162,0,0,1,1.084-.717,1.162,1.162,0,0,1,1.084.715,1.18,1.18,0,0,0,1.086.717,1.159,1.159,0,0,0,.871-.39,1.158,1.158,0,0,1,.866-.39,1.176,1.176,0,0,1,1.184,1.092v.01a1.186,1.186,0,0,0,1.177,1.092,1.16,1.16,0,0,0,.569-.148,1.164,1.164,0,0,1,.574-.153,1.2,1.2,0,0,1,.938.467,1.148,1.148,0,0,1,.2,1.012l-.005.017a1.169,1.169,0,0,0,.207,1.017,1.166,1.166,0,0,0,.928.459,1.234,1.234,0,0,0,.21-.019h.008a1.229,1.229,0,0,1,.215-.019,1.172,1.172,0,0,1,1.029.625,1.158,1.158,0,0,1-.057,1.2l-.013.021a1.172,1.172,0,0,0-.1,1.125,1.174,1.174,0,0,0,.894.688l.017,0a1.164,1.164,0,0,1,.958.875,1.161,1.161,0,0,1-.425,1.222l-.021.017a1.173,1.173,0,0,0-.456,1.032,1.174,1.174,0,0,0,.621.943l.021.01a1.164,1.164,0,0,1,.621,1.138,1.164,1.164,0,0,1-.8,1.02l-.02,0a1.179,1.179,0,0,0-.769.831,1.171,1.171,0,0,0,.283,1.09l.016.019a1.164,1.164,0,0,1,.218,1.273,1.163,1.163,0,0,1-1.08.708h-.033a1.175,1.175,0,0,0-.989.538,1.174,1.174,0,0,0-.088,1.121l.01.021a1.154,1.154,0,0,1-.083,1.116,1.175,1.175,0,0,1-.984.544,1.185,1.185,0,0,1-.4-.07h-.005a1.181,1.181,0,0,0-.395-.068,1.184,1.184,0,0,0-.87.387,1.161,1.161,0,0,0-.3.9v.013a1.157,1.157,0,0,1-.3.9,1.2,1.2,0,0,1-.883.392,1.159,1.159,0,0,1-.727-.259,1.164,1.164,0,0,0-.729-.256,1.181,1.181,0,0,0-1.15.9v0A1.168,1.168,0,0,1-4229.021-6663.778Zm-7.2-15.261a.709.709,0,0,0-.522.232l-1.041,1.122a.835.835,0,0,0,0,1.12l4.787,5.15a.712.712,0,0,0,.522.231.71.71,0,0,0,.52-.231l8.471-9.111a.84.84,0,0,0,0-1.122l-1.041-1.12a.711.711,0,0,0-.522-.232.705.705,0,0,0-.521.232l-6.908,7.43-3.226-3.469A.706.706,0,0,0-4236.221-6679.039Z"
                transform="translate(4244.209 6690.181)"
              />
            </svg>
          </span>
          Congrats your profile is verified
        </div>
      ) : (
        <div className="profile-verified-text">
          <img className="icon" src={VerificationIcon} alt="Verified" onClick={showVerificationModal} />
          Your profile is not verified for college coaches.
          <a style={{"cursor":"pointer"}} onClick={()=>window.open('https://calendly.com/sportsforce/recruiting-assessment-round-robin','_blank')}>Complete Verification Now</a>
        </div>
      )}
      <div className="save">
      { props?.buttonHide && props.buttonHide == true ? "" : (
        <button>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="13.889"
            height="13.945"
            viewBox="0 0 13.889 13.945"
          >
            <g id="save" transform="translate(0 -0.001)">
              <path
                id="Path_2125"
                data-name="Path 2125"
                d="M13.38,2.1,11.793.508A1.736,1.736,0,0,0,10.565,0H9.548V3.038a.434.434,0,0,1-.434.434H2.17a.434.434,0,0,1-.434-.434V0H.868A.868.868,0,0,0,0,.868V13.021a.868.868,0,0,0,.868.868H13.021a.868.868,0,0,0,.868-.868v-9.7A1.736,1.736,0,0,0,13.38,2.1ZM12.153,12.153H1.736V6.944H12.153Z"
                transform="translate(0 0.058)"
                fill="#3e3e3e"
              />
              <rect
                id="Rectangle_416"
                data-name="Rectangle 416"
                width="2"
                height="3"
                transform="translate(5.457 0.001)"
                fill="#3e3e3e"
              />
            </g>
          </svg>
          Save
        </button>
      )}
      </div>
      <Dialog open={showVerificationModalState}
              onClose={(event, reason)=> {
                if (reason == "backdropClick" || reason == "escapeKeyDown") {
                  showVerificationModal()
                }
              }}
      >
        <VerificationModal
            onClose={showVerificationModal}
            // profileImage={fields.profileimagename}
        />
      </Dialog>
    </div>
  );
};

const Title = ({ title }) => {
  const routeBackToProfile = () => {
    history?.push(
        {pathname: `/${getAthleteSysID()}`,
          state: {isPublic : false}
        }
        // '/profile/1'
    )
    sessionStorage.setItem('athlete_own_profile', true)
    // window.location.href = "/profile/1";
  };
  return (
    <div className="flexRow">
      <div className="title">{title}</div>
      <div className="btnWrap">
        <button
          className="btn outlined green rounded medium backprofileBtn"
          onClick={() => routeBackToProfile()}
        >
          Back To Profile
        </button>
        <button
          className="btn outlined green rounded medium"
          onClick={() => {
            routeBackToProfile();
          }}
        >
          Preview Profile
        </button>
        <button className="btn outlined blue rounded medium"
          onClick={() => {
            sessionStorage.setItem('athlete_own_profile', false)
            setTimeout(() => {
              window.open(`${websiteDefaultUrl}athlete/wyatt-johnson-74144936`, "_blank")
            }, 500)
          }}
        >
          Sample Profile
        </button>
      </div>
    </div>
  );
};

let SideBarVideo = (props) => {
  let url = window.location.href.split("/").slice(-1).toString();
  const [showAlbums, setShowAlbums] = useState(false);
  const [showTags, setShowTags] = useState(false);
  const [showAlbumEdit, setShowAlbumEdit] = useState(false);
  const [showTagEdit, setShowTagEdit] = useState(false);
  const [albumValue, setAlbumValue] = useState("");
  const [tagValue, setTagValue] = useState("");
  const [error, setError] = useState({});
  const [allAlbumList, setAllAlbumList] = useState([]);
  const [allTagsList, setAllTagsList] = useState([]);
  const [itemsToShow, setItemToShow] = useState({
    albumItemsToShow: "3",
    tagsItemsToShow: "3",
  });
  const [expanded, setExpanded] = useState({
    albumExpanded: false,
    tagsExpanded: false,
  });
  useEffect(() => {
    fetchAllAlbumsTags();
  }, []);
  useEffect(() => {
    if (
      props.allAlbumsTags &&
      props.allAlbumsTags.data &&
      props.allAlbumsTags.data.allAlbumTagsList &&
      props.allAlbumsTags.data.allAlbumTagsList.allAlbums &&
      props.allAlbumsTags.data.allAlbumTagsList.allAlbums.Albums
    ) {
      setAllAlbumList([
        ...props.allAlbumsTags.data.allAlbumTagsList.allAlbums.Albums,
      ]);
    }
    if (
      props.allAlbumsTags &&
      props.allAlbumsTags.data &&
      props.allAlbumsTags.data.allAlbumTagsList &&
      props.allAlbumsTags.data.allAlbumTagsList.allTags &&
      props.allAlbumsTags.data.allAlbumTagsList.allTags.Tags
    ) {
      setAllTagsList([
        ...props.allAlbumsTags.data.allAlbumTagsList.allTags.Tags,
      ]);
    }
  }, [props.allAlbumsTags]);
  const fetchAllAlbumsTags = () => {
    let variables = {
      where: {
        userid: getUserInfo().id,
        active: 1,
      },
    };
    props.albumTagsListStart({
      query: getAllAlbumsTags,
      variables: variables,
    });
  };
  const handleShowAlbums = () => {
    setShowAlbums(!showAlbums);
  };
  const handleShowTags = () => {
    setShowTags(!showTags);
  };
  const showAlbumEditHandler = (e) => {
    e.stopPropagation();
    setShowAlbumEdit(!showAlbumEdit);
    setError({ ...error, albumError: "" });
  };
  const showTagEditHandler = (e) => {
    e.stopPropagation();
    setShowTagEdit(!showTagEdit);
    setError({ ...error, tagError: "" });
  };
  const albumChangeHandler = (e) => {
    setAlbumValue(e.target.value);
    setError({ ...error, albumError: "" });
  };
  const tagChangeHandler = (e) => {
    setTagValue(e.target.value);
    setError({ ...error, tagError: "" });
  };
  const addAlbum = async (e) => {
    e.preventDefault();
    let albumName = albumValue.trim();
    const alfil = allAlbumList.filter(
        (el) => el?.albumname?.toLowerCase() == albumName?.toLowerCase()
      ),
      alStatus = alfil?.length > 0 ? false : true;
    if (!alStatus && albumName != "")
      return setError({ ...error, albumError: "Album Name Already Exist" });
    if (!albumName) {
      setError({ ...error, albumError: "Please enter Album Name" });
    } else {
      let variables = {
        obj: {
          userid: getUserInfo().id,
          albumname: albumName,
          active: 1,
        },
      };
      let res = await fetchGraphMethod(addAlbumQuery, variables, true);
      if (res && res.status) {
        fetchAllAlbumsTags();
        showAlbumEditHandler(e);
        setAlbumValue("");
        // messagePopup("", "Album Added Successfully", "success");
        toastr.success("Album Added Successfully", "", {
          progressBar : true,timeOut: 2000,
          closeButton: true, positionClass: "toast-top-full-width",
          showEasing: "swing", fadeIn: 40000,
          preventDuplicates: true,
        })
      } else {
        // messagePopup("", "Something went wrong. Please try again", "warning");
        toastr.warning("Something went wrong. Please try again", "", {
          progressBar : true,timeOut: 2000,
          closeButton: true, positionClass: "toast-top-full-width",
          showEasing: "swing", fadeIn: 40000,
          preventDuplicates: true,
        })
      }
    }
  };
  const addTag = async (e) => {
    e.preventDefault();
    let tagName = tagValue.trim();
    const alfil = allTagsList.filter(
        (el) => el?.tagnmae?.toLowerCase() == tagName?.toLowerCase()
      ),
      alStatus = alfil?.length > 0 ? false : true;
    if (!alStatus && tagName != "")
      return setError({ ...error, tagError: "Tag Name Already Exist" });
    if (!tagName) {
      setError({ ...error, tagError: "Please enter Tag Name" });
    } else {
      let variables = {
        obj: {
          userid: getUserInfo().id,
          tagnmae: tagName,
          active: 1,
        },
      };
      let res = await fetchGraphMethod(addTagQuery, variables, true);
      if (res && res.status) {
        fetchAllAlbumsTags();
        showTagEditHandler(e);
        setTagValue("");
        // messagePopup("", "Tag Added Successfully", "success");
        toastr.success("Tag Added Successfully", "", {
          progressBar : true,timeOut: 2000,
          closeButton: true, positionClass: "toast-top-full-width",
          showEasing: "swing", fadeIn: 40000,
          preventDuplicates: true,
        })
      } else {
        // messagePopup("", "Something went wrong. Please try again", "warning");
        toastr.warning("Something went wrong. Please try again", "", {
          progressBar : true,timeOut: 2000,
          closeButton: true, positionClass: "toast-top-full-width",
          showEasing: "swing", fadeIn: 40000,
          preventDuplicates: true,
        })
      }
    }
  };

  const deleteAlbumTag = async (e, data, isAlbum) => {
    e.preventDefault();
    if (isAlbum) {
      swal({
        title: "",
        text: "Are you sure you want to delete this album? All the videos/photos in this album will also be deleted",
        type: "warning",
        icon: "error",
        buttons: {
          confirm: {
            text: "Yes",
            value: "yes",
          },
          // roll: {
          //   text: "No",
          //   value: "no",
          // },
          cancel: "No",
        },
      }).then((flag) => {
        if (flag === "yes") {
          props.deleteAlbumStart({
            data: {
              userId: getUserInfo().id,
              albumsId: data.id,
              deleteStatus: "true",
              //done same as earlier
            },
            refreshPage: refreshAlbum,
          });
        } else if (flag === "no") {
          props.deleteAlbumStart({
            data: {
              userId: getUserInfo().id,
              albumsId: data.id,
              deleteStatus: "false",
              //done same as earlier
            },
            refreshPage: refreshAlbum,
          });
        }
      });
    } else {
      let variables = {
        obj: {
          userid: getUserInfo().id,
          id: data.id,
          active: 0,
        },
      };
      props.deleteTagStart({
        query: addTagQuery,
        variables,
        refreshPage: refreshTag,
      });
    }
  };
  const refreshTag = () => {
    fetchAllAlbumsTags();
    setTagValue("");
  };

  const refreshAlbum = () => {
    props.allVideoPhotoListStart({
      query: getAllVideoPhotoInfoQuery,
      variables: {
        obj: {
          and: [
            {
              or: [
                {
                  videophotosuploadedtype: "programAndPricing",
                },
                {
                  videophotosuploadedtype: "Post",
                  userid: getUserInfo() ? getUserInfo().id : null,
                  active: 1,
                },
                {
                  videophotosuploadedtype: "Uploaded",
                  userid: getUserInfo() ? getUserInfo().id : null,
                  active: 1,
                },
                {
                  videophotosuploadedtype: "Press",
                  userid: getUserInfo() ? getUserInfo().id : null,
                  active: 1,
                },
              ],
            },
          ],
          order: "id Desc",
        },
        //EARLIER BELOW CODE IS THERE DUE TO WHICH ALL VIDEO AND VIDEO THIS COMING WHICH IS A BUG
        // obj : {
        //        or:[
        //            {
        //             videophotosuploadedtype : "programAndPricing",
        //            },
        //            {
        //             videophotosuploadedtype : "Post",
        //            },
        //            {
        //             userid : getUserInfo() ? getUserInfo().id : null,
        //             active : 1
        //            }
        //        ]
        // }
      },
      // {
      //   obj: {
      //     userid: getUserInfo() ? getUserInfo().id : 0,
      //     active: 1,
      //   },
      // },
    });
    fetchAllAlbumsTags();
    setAlbumValue("");
  };

  const handleExpandedAlbumTags = (e, isAlbum) => {
    e.preventDefault();
    if (isAlbum) {
      let show = expanded["albumExpanded"];

      setItemToShow({
        ...itemsToShow,
        albumItemsToShow: !show ? allAlbumList.length : 3,
      });
      setExpanded({ ...expanded, albumExpanded: !show });
    } else {
      let show = expanded["tagsExpanded"];
      setItemToShow({
        ...itemsToShow,
        tagsItemsToShow: !show ? allTagsList.length : 3,
      });
      setExpanded({ ...expanded, tagsExpanded: !show });
    }
  };
  const getAllAlbums = () => {
    return (
      <>
        {allAlbumList.slice(0, itemsToShow["albumItemsToShow"]).map((album) => {
          return (
            <li
              key={album.id}
              style={{
                border: "1px solid lightgrey",
                padding: "5px",
                borderRadius: " 5px",
                display: "flex",
                alignItems: "center",
              }}
            >
              {" "}
              {album.albumname}{" "}
              <DeleteOutline
                // className="secondary"
                style={{ color: "red", marginLeft: "auto", cursor: "pointer" }}
                onClick={(e) => {
                  deleteAlbumTag(e, album, true);
                }}
              />
            </li>
          );
        })}
        {allAlbumList.length > 3 ? (
          <a
            style={{ color: "blue", margin: "10px", cursor: "pointer" }}
            onClick={(e) => {
              handleExpandedAlbumTags(e, true);
            }}
          >
            {expanded["albumExpanded"] ? (
              <span>Show less</span>
            ) : (
              <span>Show more</span>
            )}
          </a>
        ) : (
          ""
        )}
      </>
    );
  };
  const getAllTags = () => {
    return (
      <>
        {allTagsList.slice(0, itemsToShow["tagsItemsToShow"]).map((tag) => {
          return (
            <li
              key={tag.id}
              style={{
                border: "1px solid lightgrey",
                padding: "5px",
                borderRadius: " 5px",
                display: "flex",
                alignItems: "center",
              }}
            >
              {" "}
              {tag.tagnmae}{" "}
              <DeleteOutline
                style={{ color: "red", marginLeft: "auto", cursor: "pointer" }}
                onClick={(e) => {
                  deleteAlbumTag(e, tag, false);
                }}
              />
            </li>
          );
        })}{" "}
        {allTagsList.length > 3 ? (
          <a
            style={{ color: "blue", margin: "10px", cursor: "pointer" }}
            onClick={(e) => {
              handleExpandedAlbumTags(e, false);
            }}
          >
            {expanded["tagsExpanded"] ? (
              <span>Show less</span>
            ) : (
              <span>Show more</span>
            )}
          </a>
        ) : (
          ""
        )}
      </>
    );
  };
  return (
    <div className="sidebarbox">
      <BackdropLoader open={props.deleteAlbumTag.loading} />
      <ul className="menu-links">
        <li className={url == "videoPhotos" ? "active" : "i"}>
          <Link to="/videoPhotos">All</Link>
        </li>
        <li className={url == "Video" ? "active" : "i"}>
          <Link to="/videoPhotos/Video">
            Videos <span>({props.videoCount})</span>
          </Link>
        </li>
        <li className={url == "Photos" ? "active" : "i"}>
          <Link to="/videoPhotos/Photos">
            Photos <span>({props.photoCount})</span>
          </Link>
        </li>
      </ul>
      <div className="category-list">
        {/*code is commented as per BA Chnage req task 25/7/2022*/}
        {/*<div className="item">*/}
        {/*  <a*/}
        {/*    href="/#/videoPhotos/Professional"*/}
        {/*    className={`add-toggle-button ${*/}
        {/*      url == "Professional" ? "active" : "i"*/}
        {/*    }`}*/}
        {/*  >*/}
        {/*    Professional Edit*/}
        {/*  </a>*/}
        {/*</div>*/}
        {/*this below border css border added as per BA Change july 2002*/}
        <div className="item" style={{border:"none"}}>
          {/*<div*/}
          {/*  id="albums-toggle-button"*/}
          {/*  className="add-toggle-button"*/}
          {/*  onClick={handleShowAlbums}*/}
          {/*>*/}
          {/*  Albums ({allAlbumList.length}){" "}*/}
          {/*  <span className="edit-button" onClick={showAlbumEditHandler}></span>*/}
          {/*</div>*/}
          {/*{showAlbumEdit && (*/}
          {/*  <ul className="category-toggle-data">*/}
          {/*    <li>*/}
          {/*      <div className="field-box">*/}
          {/*        <input*/}
          {/*          type="text"*/}
          {/*          // style={{ width: "100%", marginTop: "10px" }}*/}
          {/*          onChange={albumChangeHandler}*/}
          {/*          value={albumValue}*/}
          {/*        />*/}
          {/*      </div>*/}
          {/*      {error["albumError"] ? (*/}
          {/*        <p style={{ color: "red" }}>{error["albumError"]}</p>*/}
          {/*      ) : (*/}
          {/*        ""*/}
          {/*      )}*/}
          {/*      <div className="button-box">*/}
          {/*        <span className="close-button-c">*/}
          {/*          <CloseRounded*/}
          {/*            fontSize="large"*/}
          {/*            onClick={showAlbumEditHandler}*/}
          {/*            style={{ color: "red" }}*/}
          {/*          />*/}
          {/*        </span>*/}

          {/*        <button className="btn green" onClick={addAlbum}>*/}
          {/*          Create Album*/}
          {/*        </button>*/}
          {/*      </div>*/}
          {/*    </li>*/}
          {/*  </ul>*/}
          {/*)}*/}
          {/*{showAlbums && (*/}
          {/*  <ul id="albums-toggle-data" className="category-toggle-data">*/}
          {/*    {getAllAlbums()}*/}
          {/*  </ul>*/}
          {/*)}*/}
        </div>
        {/*this below border css border added as per BA Change july 2002*/}
        <div className="item" style={{border:"none"}}>
          {/*<div*/}
          {/*  id="tags-toggle-button"*/}
          {/*  className="add-toggle-button"*/}
          {/*  onClick={handleShowTags}*/}
          {/*>*/}
          {/*  Tags ({allTagsList.length})*/}
          {/*  <span className="edit-button" onClick={showTagEditHandler}></span>*/}
          {/*</div>*/}
          {/*{showTagEdit && (*/}
          {/*  <ul className="category-toggle-data">*/}
          {/*    <li>*/}
          {/*      <div className="field-box">*/}
          {/*        <input*/}
          {/*          type="text"*/}
          {/*          // style={{ width: "100%", marginTop: "10px" }}*/}
          {/*          onChange={tagChangeHandler}*/}
          {/*          value={tagValue}*/}
          {/*        />*/}
          {/*      </div>*/}
          {/*      {error["tagError"] ? (*/}
          {/*        <p style={{ color: "red" }}>{error["tagError"]}</p>*/}
          {/*      ) : (*/}
          {/*        ""*/}
          {/*      )}*/}
          {/*      <div className="button-box">*/}
          {/*        <span className="close-button-c">*/}
          {/*          <CloseRounded*/}
          {/*            fontSize="large"*/}
          {/*            onClick={showTagEditHandler}*/}
          {/*            style={{ cursor: "pointer", color: "red" }}*/}
          {/*          />*/}
          {/*        </span>*/}

          {/*        <button className="btn green" onClick={addTag}>*/}
          {/*          Create Tag*/}
          {/*        </button>*/}
          {/*      </div>*/}
          {/*    </li>*/}
          {/*  </ul>*/}
          {/*)}*/}
          {/*{showTags && (*/}
          {/*  <ul id="tags-toggle-data" className="category-toggle-data">*/}
          {/*    {getAllTags()}*/}
          {/*  </ul>*/}
          {/*)}*/}
        </div>
      </div>
    </div>
  );
};

const LinkVideoOverlay = ({
  onLinkModal,
  onSaveLink,
  onLinkCloseModal,
  errors,
  setErrors,
}) => {
  const [linkValue, setLinkValue] = useState("");

  const handleChange = (e) => {
    e.preventDefault();
    setLinkValue(e.target.value);
    setErrors({ errors: "" });
  };
  const saveLinkData = (e) => {
    e.preventDefault();
    onSaveLink(linkValue);
  };
  return (
    <div
      className="modal fade common-modal show modalActive"
      id="AddVideoModal"
      style={{ display: "block" }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <form className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              Add a video from YouTube, HUDL, or Vimeo
            </h5>
          </div>
          <div className="modal-body">
            <div className="form-group">
              <label>Grab your video's URL address or share link</label>
              <input
                type="text"
                value={linkValue}
                onChange={(e) => handleChange(e)}
                id="video-url-entry"
                placeholder="Paste your video URL here"
              />
              <div className="error" style={{textAlign: "left" }}>
                {errors["data"]}
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn blue"
              id="video-url-next-button"
              onClick={(e) => saveLinkData(e)}
            >
              Next
            </button>
            <button type="button" className="btn" onClick={onLinkCloseModal}>
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

const mapStateToProps1 = (state) => {
  return {
    savePost: state.athlete.dashboard.home.savePost,
    userData: state.common.userData,
  };
};
const mapDispatchToProps1 = (dispatch) => {
  return {
    savePostStart: (data) => dispatch(savePostStart(data)),
  };
};

const TimelinePostOverlay = connect(
  mapStateToProps1,
  mapDispatchToProps1
)((props) => {
  const [description, setDescription] = useState("");
  const [postStatus, setPostStatus] = useState("public");
  const [userPic, setUserPic] = useState(null);
  const prevData = usePrevious(props.savePost.data);
  const [vidID, setVidID] = useState(null)
  const [isVidPop, setIsVidPop] = useState(false)
  const [isLink, setIsLink] = useState(false)
  useEffect(() => {
    if (props.athleteData) {
      const { onboardingData } = props.athleteData;
      const tempPic = onboardingData
        ? onboardingData.profileimages
          ? `${imageDownloadUrl}/${onboardingData.profileimages}`
          : ""
        : "";
      setUserPic(tempPic);
    }
  }, [props.athleteData]);

  useEffect(() => {
    if (props.savePost.data && prevData !== props.savePost.data) {
      props.onShowTimeLine();
      props.onSaveTimeline(props.data);
    }
  }, [props.savePost]);

  const saveData = () => {
    let tempObj = {
      userid: getUserInfo()?.id,
      postdescription: description,
    };
    if (postStatus === "public") {
      tempObj = { ...tempObj, ispublic: 1, isprivate: 0 };
    }
    if (postStatus === "private") {
      tempObj = { ...tempObj, isprivate: 1, ispublic: 0 };
    }
    const name = props.data
      ? props.data.isphotosorvideoslik === 0
        ? props.data.photosname
        : props.data.isphotosorvideoslik === 1
        ? props.data.videoname
        : props.data.videolink
      : null;
    const typeofpost = props.data
      ? props.data.isphotosorvideoslik === 0
        ? 1
        : props.data.isphotosorvideoslik === 1
        ? 2
        : props.data.isphotosorvideoslik === 2
        ? 4
        : null
      : null;
    const photovideoid = props?.data?.id
    const thumbnail = !!props?.data?.thumbnail ? props?.data?.thumbnail : null
    props.savePostStart({
      postQuery: savePostQuery,
      mediaQuery: saveMediaQuery,
      postData: {
        obj: tempObj,
      },
      mediaData: [
        {
          postimagevideoandlinkurl: name,
          typeofpost,
          thumbnail,
          photovideoid
        },
      ],
      getPosts: null,
      userActivityQuery: updatePostsQuery,
      photoAndVideoId: props.data.id,
    });
  };

  return (
      <>
    <div
      className="modal fade video-post-modal show"
      style={{ display: "block" }}
    >
      <BackdropLoader open={props.savePost.loading} />
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header" style={{borderBottom:"none", padding:"10px 10px 0 0"}}>
            {/*<h5 className="modal-title">Timeline Post</h5>*/}
            <button
              type="button"
              className="close"
              onClick={() => props.onShowTimeLine()}
            >
              <img src={closeGrayIcon} alt="close Gray Icon" />
            </button>
          </div>
          <div className="modal-body">
            <h1 style={{textAlign:"center"}}>Do you want to post it again publically?</h1>
            <div className="post-video-box">
              {/*<div className="img-box">*/}
                {/*{props.data ? (*/}
                {/*  props.data.isphotosorvideoslik === 0 ? (*/}
                {/*    <img src={`${imageDownloadUrl}/${props.data.photosname}`} />*/}
                {/*  ) : props.data.isphotosorvideoslik === 1 ? (*/}
                {/*    <>*/}
                {/*      <video*/}
                {/*        // controls*/}
                {/*        //  controlsList={getAuthToken() ? "" : "nodownload"}*/}
                {/*    >*/}
                {/*      <source*/}
                {/*        src={`${imageDownloadUrl}/${props.data.videoname}`}*/}
                {/*        alt="video"*/}
                {/*      />*/}
                {/*    </video>*/}
                {/*      <div*/}
                {/*          className="video-play-button"*/}
                {/*          onClick={() => openVideoOnNewTab(`${imageDownloadUrl}/${props.data.videoname}`, false)}*/}
                {/*      >*/}
                {/*        <div className="video-play-inner">*/}
                {/*          <button>*/}
                {/*            <svg*/}
                {/*                xmlns="http://www.w3.org/2000/svg"*/}
                {/*                width="8"*/}
                {/*                height="14"*/}
                {/*                viewBox="0 0 8 14"*/}
                {/*            >*/}
                {/*              <path*/}
                {/*                  className="a"*/}
                {/*                  d="M8.1,0l8.1,10.8H0Z"*/}
                {/*                  transform="translate(8) rotate(90)"*/}
                {/*              ></path>*/}
                {/*            </svg>*/}
                {/*          </button>*/}
                {/*        </div>*/}
                {/*      </div>*/}
                {/*      </>*/}
                {/*  ) : (*/}
                {/*    <>*/}
                {/*      <video*/}
                {/*          // controls*/}
                {/*          poster={*/}
                {/*            getThumbnail(props.data.videolink, props.data, 'Vid/Photo')}*/}
                {/*      >*/}
                {/*        <source src={props.data.videolink} alt="video" />*/}
                {/*      </video>*/}
                {/*      <div*/}
                {/*        className="video-play-button"*/}
                {/*        onClick={() => openVideoOnNewTab(props.data?.videolink, true)}*/}
                {/*      >*/}
                {/*        <div className="video-play-inner">*/}
                {/*          <button>*/}
                {/*            <svg*/}
                {/*              xmlns="http://www.w3.org/2000/svg"*/}
                {/*              width="8"*/}
                {/*              height="14"*/}
                {/*              viewBox="0 0 8 14"*/}
                {/*            >*/}
                {/*              <path*/}
                {/*                className="a"*/}
                {/*                d="M8.1,0l8.1,10.8H0Z"*/}
                {/*                transform="translate(8) rotate(90)"*/}
                {/*              ></path>*/}
                {/*            </svg>*/}
                {/*          </button>*/}
                {/*        </div>*/}
                {/*      </div>*/}
                {/*    </>*/}
                {/*  )*/}
                {/*) : (*/}
                {/*  ""*/}
                {/*)}*/}
              {/*</div>*/}
              <div className="content-box">
                {/*<h4>*/}
                {/*  {getUserInfo()*/}
                {/*    ? getUserInfo().FirstName*/}
                {/*      ? getUserInfo().FirstName +*/}
                {/*        " " +*/}
                {/*        (getUserInfo().lastName ? getUserInfo().lastName : "")*/}
                {/*      : getUserInfo().lastName*/}
                {/*      ? getUserInfo().lastName*/}
                {/*      : ""*/}
                {/*    : ""}*/}
                {/*</h4>*/}
                {/*{props.data && props.data.isphotosorvideoslik === 0 ? (*/}
                {/*  <p>*/}
                {/*    {props.data.albumid ? (*/}
                {/*      <span style={{ display: "block" }}>*/}
                {/*        Album :{" "}*/}
                {/*        {*/}
                {/*          props.data.uploadedvideoandphotoalbumidmaprel*/}
                {/*            ?.Albums[0]?.albumname*/}
                {/*        }*/}
                {/*      </span>*/}
                {/*    ) : (*/}
                {/*      ""*/}
                {/*    )}*/}
                {/*    {props.data.tagid ? (*/}
                {/*      <span style={{ display: "block" }}>*/}
                {/*        Tag :{" "}*/}
                {/*        {*/}
                {/*          props.data.uploadedvideoandphototagidmaprel?.Tags[0]*/}
                {/*            ?.tagnmae*/}
                {/*        }*/}
                {/*      </span>*/}
                {/*    ) : (*/}
                {/*      ""*/}
                {/*    )}*/}
                {/*  </p>*/}
                {/*) : null}*/}
                {/*{props.data && props.data.isphotosorvideoslik !== 0 ? (*/}
                {/*  <p>*/}
                {/*    {props.data.position ? (*/}
                {/*      <span style={{ display: "block" }}>*/}
                {/*        Position : {props.data.position}*/}
                {/*      </span>*/}
                {/*    ) : (*/}
                {/*      ""*/}
                {/*    )}*/}
                {/*    {props.data.jerseyno ? (*/}
                {/*      <span style={{ display: "block" }}>*/}
                {/*        Jersey : {props.data.jerseyno}*/}
                {/*      </span>*/}
                {/*    ) : (*/}
                {/*      ""*/}
                {/*    )}*/}
                {/*    {props.data.jerseycolor ? (*/}
                {/*      <span style={{ display: "block" }}>*/}
                {/*        Jersey Color : {props.data.jerseycolor}*/}
                {/*      </span>*/}
                {/*    ) : (*/}
                {/*      ""*/}
                {/*    )}*/}
                {/*  </p>*/}
                {/*) : null}*/}
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn blue"
              onClick={() => saveData()}
            >
              {/*Post*/}
              Yes
            </button>
            <button
              type="button"
              className="btn"
              onClick={() => props.onShowTimeLine()}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
        <VideoPop
        isTestSingle={isVidPop}
        setIsTestSingle={()=>setIsVidPop(false)}
        vidID={vidID}
        isToken={ 1 }
        isLink={ isLink }
        />
    </>
  );
});
const VideoOverlay = ({
  onVideoOpen,
  onVideoClose,
  videoOpen,
  videoData = null,
}) => {
  const sourceURL = isNaN(videoData)
    ? `https://www.youtube.com/embed/${videoData ? videoData : "aqz-KE-bpKQ"}`
    : `https://player.vimeo.com/video/${videoData && videoData}`;
  return (
    <Dialog
      open={videoOpen}
      maxWidth={"lg"}
      className={"videoOverlayWrap"}
      onClick={(event, reason)=> {
        if (reason == "backdropClick" || reason == "escapeKeyDown") {
          onVideoClose()
        }
      }}
    >
      <IconButton
        aria-label="close"
        className={"closeBtnVideo"}
        onClick={onVideoClose}
        size="large">
        <CloseIcon />
      </IconButton>
      <iframe
        width="700"
        height="400"
        src={sourceURL}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </Dialog>
  );
};

const VideoBox = (props) => {
  const {
    index,
    handleModal,
    onShowTimeLine,
    onEditVideo,
    data,
    onDownloadClick,
    onRemoveFeatureClick,
    onClickFeatured,
    deletePhotoVideo,
    handleToggleClick,
    removeFromTimeline,
    settingIconStatus,
    handleSettingDropDown,
  } = props;

  const [isVisible, setIsVisible] = useState(false);
  const [showOnTimelineOrDashboard, setShowOnTimelineOrDashboard] = useState(false);
  const [sourceSrc, setSourceSrc] = useState("");
  const [vidID, setVidID] = useState(null)
  const [isVidPop, setIsVidPop] = useState(false)
  const [isLink, setIsLink] = useState(false)
  const classes = useStyles();

  useEffect(() => {
    setIsVisible(data?.isvisible === 1 ? true : false);
    setShowOnTimelineOrDashboard(data?.showOnTimelineOrDashboard ? true : false);
    // Reload video tag
    document.getElementById(`videoplayer${index}`)?.load();
    setSourceSrc(`${imageDownloadUrl + "/" + data?.videoname}`);
  }, [data]);

  const onToggleClick = (e, data) => {
    handleToggleClick({
      ...data,
      userid: data.userid,
      id: data.id,
      isvisible: e.target.checked ? 1 : 0,
      userActivityId: data.userActivityId,
    });
  };

  const showTimelineClick = (e, data) => {
    if (e?.target?.checked || e ) {
      onShowTimeLine(data);
    } else {
      removeFromTimeline(data);
    }
  };

  // const videoId = data && data.videolink.split('/')[3]
  const openVideoOnNewTab = (url, linkType, data) => {
    if (url) {
      // window.open(url, "_blank");
      setVidID(url)
      setIsLink(linkType)
      setTimeout(()=>{
        setIsVidPop(true)
      },500)
      vidCountIncre(data, true)
    }
  };

  return (
    <>
      <li
        className={`${
          data.videophotosuploadedtype !== "ProgramAndPricing" &&
          !data.isfeatured
            ? "item"
            : ""
        } video-box handle`}
      >
        <div className="img-box">
          {data ? (
            data.isphotosorvideoslik === 1 ? (
              <>
                <video
                  // controls
                  id={`videoplayer${index}`}
                >
                  <source
                    id={`video_res_${index}`}
                    src={sourceSrc ? typeConvert(sourceSrc, 'video/photo')+"#t=0.2" : ""}
                    alt="video"
                  />
                </video>
                <div
                  className="video-play-button"
                  onClick={() => openVideoOnNewTab(sourceSrc, false, data)}
                  // onClick={() => onVideoOpen(videoId && videoId)}
                >
                  <div className="video-play-inner">
                    <button>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="10.802"
                        height="16.203"
                        viewBox="0 0 10.802 16.203"
                      >
                        <defs></defs>
                        <path
                          className="a"
                          d="M8.1,0l8.1,10.8H0Z"
                          transform="translate(10.802) rotate(90)"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </>
            ) : (
              <>
                <video
                  poster={getThumbnail(data?.videolink, data, 'Vid/Photo')}
                >
                  <source src={data?.videolink} alt="video/youtube" />
                </video>
                {/* <video
                  poster={`https://img.youtube.com/vi/${
                    videoId ? videoId : null
                  }/mqdefault.jpg`}
                ></video> */}
                <div
                  className="video-play-button"
                  onClick={() => openVideoOnNewTab(props.data?.videolink, true, data)}
                  // onClick={() => onVideoOpen(videoId && videoId)}
                >
                  <div className="video-play-inner">
                    <button>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="10.802"
                        height="16.203"
                        viewBox="0 0 10.802 16.203"
                      >
                        <defs></defs>
                        <path
                          className="a"
                          d="M8.1,0l8.1,10.8H0Z"
                          transform="translate(10.802) rotate(90)"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </>
            )
          ) : null}
          {data.videophotosuploadedtype !== "ProgramAndPricing" ? (
            <ul className="info-icon">
              <li
                className={`button-favorite ${data?.isfeatured && "active"}`}
                onClick={() => {
                  if (data?.isvisible == 1){
                    if (!data?.isfeatured) {
                      onClickFeatured(data);
                    } else {
                      onRemoveFeatureClick(data);
                    }
                  }
                }}
              >
                <Tooltip arrow
                  title={data?.isvisible == 1 ? (
                      data?.isfeatured ? "Click here to remove it as your featured video" : "Click here to make it as your featured video"
                    ) : (
                      "Only public videos can be featured"
                    ) 
                  }
                  placement="top"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15.057"
                    height="14.43"
                    viewBox="0 0 15.057 14.43"
                    aria-disabled={data?.isvisible == 1 ? true : false }
                  >
                    <defs></defs>
                    <path
                      className="a"
                      d="M15.018,5.948a.8.8,0,0,0-.688-.55L9.983,5,8.265.982a.8.8,0,0,0-1.473,0L5.075,5,.727,5.4A.8.8,0,0,0,.272,6.8L3.558,9.68l-.969,4.267a.8.8,0,0,0,1.191.865l3.748-2.241,3.747,2.241a.8.8,0,0,0,1.192-.865L11.5,9.68,14.784,6.8a.8.8,0,0,0,.233-.851ZM7.6,12.528"
                      transform="translate(0 -0.496)"
                    />
                  </svg>
                </Tooltip>
              </li>

              <li
                className="delete-button"
                onClick={() => deletePhotoVideo(data)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="9.677"
                  height="11.91"
                  viewBox="0 0 9.677 11.91"
                >
                  <g transform="translate(-48)">
                    <path
                      className="a"
                      d="M56.746,1.489H54.7V1.117A1.117,1.117,0,0,0,53.583,0H52.094a1.117,1.117,0,0,0-1.117,1.117v.372H48.93a.93.93,0,0,0-.93.93v.744a.372.372,0,0,0,.372.372H57.3a.372.372,0,0,0,.372-.372V2.419A.93.93,0,0,0,56.746,1.489Zm-5.024-.372a.373.373,0,0,1,.372-.372h1.489a.373.373,0,0,1,.372.372v.372H51.722Z"
                    />
                    <path
                      className="a"
                      d="M73.48,184a.116.116,0,0,0-.116.122l.307,6.444a1.115,1.115,0,0,0,1.115,1.064h5.652a1.115,1.115,0,0,0,1.115-1.064l.307-6.444a.116.116,0,0,0-.116-.122Zm5.621.93a.372.372,0,0,1,.744,0v4.838a.372.372,0,1,1-.744,0Zm-1.861,0a.372.372,0,0,1,.744,0v4.838a.372.372,0,1,1-.744,0Zm-1.861,0a.372.372,0,0,1,.744,0v4.838a.372.372,0,1,1-.744,0Z"
                      transform="translate(-24.774 -179.72)"
                    />
                  </g>
                </svg>
              </li>
              {/* This is the original 'Share' button before adding the new one next to the blue 'Repost' button
              <li className="share-button" onClick={() => handleModal(data)}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10.689"
                  height="11.803"
                  viewBox="0 0 10.689 11.803"
                >
                  <path
                    d="M13.4,11.457a1.623,1.623,0,0,0-1.161.445L7.984,9.44a1.994,1.994,0,0,0,.06-.415,1.993,1.993,0,0,0-.06-.415l4.2-2.432a1.782,1.782,0,1,0-.566-1.3,1.982,1.982,0,0,0,.06.415L7.478,7.72a1.792,1.792,0,0,0-1.221-.474A1.763,1.763,0,0,0,4.5,9.025a1.793,1.793,0,0,0,3.007,1.3l4.228,2.461a1.488,1.488,0,0,0-.06.385,1.727,1.727,0,1,0,1.727-1.72Z"
                    transform="translate(-4.5 -3.094)"
                  />
                </svg>
              </li>
              */}
            </ul>
          ) : null}
        </div>
        <div
          className="video-detail-box"
          style={{
            background: settingIconStatus ? "#c4c4c4" : "white"
          }}
        >
          <div className="title-box">
            <div className="title half">
              {data?.isphotosorvideoslik === 1
                ? data?.originalname
                  ? data.originalname
                  : "Video"
                : data?.originalname
                ? data.originalname === "Video"
                  ? `${data.originalname}`
                  : `${data.originalname}`
                : "Video"}
            </div>
            <div className="switch-video-button half">
              <div className="form-check form-switch">
                <label
                  className="form-check-label"
                  htmlFor="flexSwitchCheckDefault"
                >
                  {"Public?"}
                </label>
                <Switch
                  checked={isVisible}
                  onChange={(e) => onToggleClick(e, data)}
                  color="primary"
                  name="checkedB"
                  className={classes.toggle}
                  disabled={data.videophotosuploadedtype === "ProgramAndPricing"}
                />
              </div>
            </div>
          </div>
          <div className="video-info">
            <div className="half">
              <span>
                Video Type :{" "}
                {data?.videophotosuploadedtype
                  ? data.videophotosuploadedtype
                  : ""}
              </span>
              <span>
                {data?.viewvideoVideoidMap?.totalCount ?? 0} Views -
                {postDateFormat(data?.createdon)}</span>
            </div>
            <div className="half video-select-options">
              <span className="handle drag-button">
                <Tooltip
                  title={"Drag and drop"} arrow
                  placement="top"
                >
                  <img 
                    style={{ width: "40px" }} 
                    src={moveIcon} 
                    alt="move Icon" 
                  />
                </Tooltip>
              </span>
              <span className="settings-button">
                <img
                  src={settingsIcon}
                  onClick={handleSettingDropDown}
                  alt="settings Icon"
                />
                <ul
                  className="video-settings-option"
                  style={{ display: settingIconStatus ? "block" : "none" }}
                >
                  {data.videophotosuploadedtype !== "ProgramAndPricing" ? (
                    <li>
                      <a
                        onClick={() => {
                          onEditVideo(data, true);
                          handleSettingDropDown();
                        }}
                      >
                        Edit
                      </a>
                    </li>
                  ) : null}
                  {props.data && props.data.isphotosorvideoslik !== 2 ? (
                    <li>
                      <a
                        onClick={() => {
                          onDownloadClick(data);
                          handleSettingDropDown();
                        }}
                      >
                        Download
                      </a>
                    </li>
                  ) : null}
                  {data.videophotosuploadedtype !== "ProgramAndPricing" ? (
                    <>
                      {data?.isfeatured ? (
                        <li style={data.isvisible == 0 ? {cursor:"not-allowed", pointerEvents:"none", opacity:"0.6"} : {}}>
                          <a
                            onClick={() => {
                              onRemoveFeatureClick(data);
                              handleSettingDropDown();
                            }}
                          >
                            Remove Featured
                          </a>
                        </li>
                      ) : (
                        <li style={data.isvisible == 0 ? {cursor:"not-allowed", pointerEvents:"none", opacity:"0.6"} : {}}>
                          <a
                            onClick={() => {
                              onClickFeatured(data);
                              handleSettingDropDown();
                            }}
                          >
                            Make Feature
                          </a>
                        </li>
                      )}
                      <li>
                        <a
                          onClick={() => {
                            deletePhotoVideo(data);
                            handleSettingDropDown();
                          }}
                        >
                          Delete
                        </a>
                      </li>
                    </>
                  ) : null}
                </ul>
              </span>
            </div>
          </div>
          <div className="video-text">
            <p className="checkbox-list">
              <span data-toggle="modal" data-target="#VideoPostVIDEOModal">
                <button
                  className={"btn btn-orange"}
                  onClick={() => {
                    if (!data?.actualProfilePhoto) {
                      handleModal(data);
                    }
                  }}
                >
                  Share
                </button>
                <button className={"btn btn-blue"}
                  onClick={() => {
                    if (isVisible == 1) {
                      showTimelineClick(true, data)
                    } else {
                      swal({text: "Please make your photo / video public to post again", icon: "warning"})
                    }
                  }}
                >
                  Repost
                </button>
                {/* <button className={"btn btn-blue"}*/}
                {/*         style={{height:"26px", lineHeight:"0.1", marginLeft:"10px"}}*/}
                {/*         onClick={()=> showTimelineClick(false, data)}*/}
                {/*         disabled={showOnTimelineOrDashboard ? false : true}*/}
                {/* >*/}
                {/*  Remove*/}
                {/*</button>*/}
                {/*<input*/}
                {/*  type="checkbox"*/}
                {/*  checked={showOnTimelineOrDashboard}*/}
                {/*  onChange={(e) => showTimelineClick(e, data)}*/}
                {/*  disabled={*/}
                {/*    data.videophotosuploadedtype === "ProgramAndPricing"*/}
                {/*  }*/}
                {/*/>*/}
                {/*<label>*/}
                {/*  Post on your timeline*/}
                {/*  /!*Check here to post it on your Timeline*!/*/}
                {/*</label>*/}
              </span>
            </p>
          </div>
        </div>
      </li>
      <VideoPop
        isTestSingle={isVidPop}
        setIsTestSingle={()=>setIsVidPop(false)}
        vidID={vidID}
        isLink={isLink}
        isToken={ 1 }
      />
    </>
  );
};

const warningDeleteParentPopup = async (title, text, icon) => {
  const willDelete = await swal({
    title: title,
    text: text,
    icon: icon,
    buttons: {
      confirm: { text: "Ok" },
      cancel: "Cancel",
    },
    dangerMode: true,
  });
  return willDelete;
};

const PhotoBox = (props) => {
  const {
    index,
    handleModal,
    onShowTimeLine,
    onEditVideo,
    data,
    onDownloadClick,
    onRemoveFeatureClick,
    onClickFeatured,
    deletePhotoVideo,
    handleToggleClick,
    removeFromTimeline,
    settingIconStatus,
    handleSettingDropDown,
    onAddRemoveProfile,
    videoPhotoLists,
  } = props;

  const [isVisible, setIsVisible] = useState(false);
  const [showOnTimelineOrDashboard, setShowOnTimelineOrDashboard] = useState(false);
  const [sourceSrc, setSourceSrc] = useState("");
  const [addProfile, setAddProfile] = useState(false);
  const [isDrag, setIsDrag] = useState(false)
  const classes = useStyles();

  useEffect(() => {
    setIsVisible(data?.isvisible === 1 ? true : false);
    setShowOnTimelineOrDashboard(data?.showOnTimelineOrDashboard ? true : false);
    setAddProfile(data?.isprofileimage ? true : false);
    setSourceSrc(`${imageDownloadUrl + "/" + data?.photosname}`);
  }, [data]);

  const onToggleClick = (e, data) => {
    handleToggleClick({
      ...data,
      userid: data.userid,
      id: data.id,
      isvisible: e.target.checked ? 1 : 0,
      userActivityId: data.userActivityId,
    });
  };

  const showTimelineClick = (e, data) => {
    if (e?.target?.checked || e) {
      onShowTimeLine(data);
    } else {
      removeFromTimeline(data);
    }
  };

  const addRemoveToProfile = (e, data) => {
    const tempArray = [];

    videoPhotoLists && videoPhotoLists.map((item) => {
      if (item.isprofileimage) {
        tempArray.push(item);
      }
    });

    let filteredPhoto = tempArray.filter(
      (item) => item.actualProfilePhoto !== true
    );

    filteredPhoto = filteredPhoto.sort(
      (a, b) => +a.addprofilephotodate - +b.addprofilephotodate
    );

    const firstObject = filteredPhoto && filteredPhoto[0];

    if (e.target.checked) {
      if (tempArray.length < 5) {
        onAddRemoveProfile(data, e.target.checked);
      } else {
        swal({
          text: "Are you sure you want to remove your first one profile picture ?",
          icon: "warning",
          buttons: {
            confirm: { text: "Yes" },
            cancel: "No",
          },
        }).then((okay) => {
          if (okay) {
            onAddRemoveProfile(firstObject, false);
            onAddRemoveProfile(data, true);
          }
        });
      }
    } else {
      onAddRemoveProfile(data, e.target.checked);
    }
  };

  // const getProfielPhoto = videoPhotoLists && videoPhotoLists.map((item) => {
  //   if(item.isphotosorvideoslik === 0)
  //   {
  //     return item
  //   }
  // })

  return (
    <li
      className={`${
        data.videophotosuploadedtype !== "ProgramAndPricing" &&
        !data.actualProfilePhoto
          ? "item"
          : ""
      } video-box handle`}
    >
      <div className="img-box">
        <img
          id={`photos_tag${index}`}
          src={sourceSrc ? sourceSrc : ""}
          alt="profile Bg"
        />
        {!(
          data?.actualProfilePhoto ||
          data.videophotosuploadedtype === "ProgramAndPricing"
        ) ? (
          <ul className="info-icon">
            {data.isphotosorvideoslik !== 0 ? (
              <li
                className={`button-favorite ${data?.isfeatured && "active"}`}
                onClick={() => {
                  if (!data?.actualProfilePhoto) {
                    if (!data?.isfeatured) {
                      onClickFeatured(data);
                    } else {
                      onRemoveFeatureClick(data);
                    }
                  }
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15.057"
                  height="14.43"
                  viewBox="0 0 15.057 14.43"
                >
                  <defs></defs>
                  <path
                    className="a"
                    d="M15.018,5.948a.8.8,0,0,0-.688-.55L9.983,5,8.265.982a.8.8,0,0,0-1.473,0L5.075,5,.727,5.4A.8.8,0,0,0,.272,6.8L3.558,9.68l-.969,4.267a.8.8,0,0,0,1.191.865l3.748-2.241,3.747,2.241a.8.8,0,0,0,1.192-.865L11.5,9.68,14.784,6.8a.8.8,0,0,0,.233-.851ZM7.6,12.528"
                    transform="translate(0 -0.496)"
                  />
                </svg>
              </li>
            ) : null}

            <li
              className="delete-button"
              onClick={() => {
                if (!data?.actualProfilePhoto) {
                  deletePhotoVideo(props.data);
                }
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="9.677"
                height="11.91"
                viewBox="0 0 9.677 11.91"
              >
                <defs></defs>
                <g transform="translate(-48)">
                  <path
                    className="a"
                    d="M56.746,1.489H54.7V1.117A1.117,1.117,0,0,0,53.583,0H52.094a1.117,1.117,0,0,0-1.117,1.117v.372H48.93a.93.93,0,0,0-.93.93v.744a.372.372,0,0,0,.372.372H57.3a.372.372,0,0,0,.372-.372V2.419A.93.93,0,0,0,56.746,1.489Zm-5.024-.372a.373.373,0,0,1,.372-.372h1.489a.373.373,0,0,1,.372.372v.372H51.722Z"
                  />
                  <path
                    className="a"
                    d="M73.48,184a.116.116,0,0,0-.116.122l.307,6.444a1.115,1.115,0,0,0,1.115,1.064h5.652a1.115,1.115,0,0,0,1.115-1.064l.307-6.444a.116.116,0,0,0-.116-.122Zm5.621.93a.372.372,0,0,1,.744,0v4.838a.372.372,0,1,1-.744,0Zm-1.861,0a.372.372,0,0,1,.744,0v4.838a.372.372,0,1,1-.744,0Zm-1.861,0a.372.372,0,0,1,.744,0v4.838a.372.372,0,1,1-.744,0Z"
                    transform="translate(-24.774 -179.72)"
                  />
                </g>
              </svg>
            </li>
          </ul>
        ) : (
          ""
        )}
      </div>
      <div
        className="video-detail-box"
        style={{ background: settingIconStatus ? "#c4c4c4" : "white" }}
      >
        <div className="title-box">
          <div className="title half">
            {
              data.videophotosuploadedtype !== "ProgramAndPricing" ? (
                data?.originalname ? data?.originalname : "Photo"
              ) : (
                data?.originalname ? data?.originalname : "Testimonial"
              )
            }
          </div>
          <div className="switch-video-button half">
            {data?.actualProfilePhoto != true &&
            <div className="form-check form-switch">
              <label
                  className="form-check-label"
                  htmlFor="flexSwitchCheckDefault"
              >
                {"Public?"}
              </label>
              <Switch
                  checked={data?.actualProfilePhoto ? true : isVisible}
                  onChange={(e) => onToggleClick(e, data)}
                  color="primary"
                  name="checkedB"
                  className={classes.toggle}
                  disabled={
                    data?.actualProfilePhoto ||
                    data.videophotosuploadedtype === "ProgramAndPricing"
                  }
              />
            </div>
            }
          </div>
        </div>
        <div className="video-info">
          <div className="half">
            <span>
              Photo Type :{" "}
              {data?.videophotosuploadedtype
                ? data?.videophotosuploadedtype
                : ""}
            </span>
            {!(
              data?.actualProfilePhoto ||
              data.videophotosuploadedtype === "ProgramAndPricing"
            ) ? (
              <span>
                {/*below is commented as per task aug no 36*/}
                {/*0 Views -  */}
                {postDateFormat(props?.data?.updatedon)}
              </span>
            ) :
                //earlier in false condition there was null we are not showing the date
            <span>
              {postDateFormat(props?.data?.updatedon)}
            </span>
            }
          </div>
          <div className="half video-select-options">
            {data?.actualProfilePhoto != true &&
            <span className="handle drag-button">
              <Tooltip
                title={'Drag and drop'}
                placement="top"
              >
              <img style={isDrag ? {width: "40px", cursor: "grabbing"} : {width: "40px", cursor: "pointer"}}
                src={moveIcon}
                onMouseOver={() => setIsDrag(true)}
                onMouseOut={() => setIsDrag(false)}
                alt="move Icon"
              />
              </Tooltip>
            </span>
            }
            <span className="settings-button">
              <img
                src={settingsIcon}
                onClick={handleSettingDropDown}
                alt="settings Icon"
              />
              <ul
                className="video-settings-option"
                style={{ display: settingIconStatus ? "block" : "none" }}
              >
                {!(
                  data?.actualProfilePhoto ||
                  data.videophotosuploadedtype === "ProgramAndPricing"
                ) ? (
                  <li>
                    <a
                      onClick={() => {
                        onEditVideo(data, true);
                        handleSettingDropDown();
                      }}
                    >
                      Edit
                    </a>
                  </li>
                ) : null}

                <li>
                  <a
                    onClick={() => {
                      onDownloadClick(data);
                      handleSettingDropDown();
                    }}
                  >
                    Download
                  </a>
                </li>
                {!data?.actualProfilePhoto && data.isphotosorvideoslik !== 0 ? (
                  data?.isfeatured ? (
                    <li>
                      <a
                        onClick={() => {
                          onRemoveFeatureClick(data);
                          handleSettingDropDown();
                        }}
                      >
                        Remove Featured
                      </a>
                    </li>
                  ) : (
                    <li>
                      <a
                        onClick={() => {
                          onClickFeatured(data);
                          handleSettingDropDown();
                        }}
                      >
                        Make Feature
                      </a>
                    </li>
                  )
                ) : null}
                {!(
                  // data?.actualProfilePhoto || //this line is commented as now user can delete profile photo 21/9/2022
                  data.videophotosuploadedtype === "ProgramAndPricing"
                ) ? (
                  <li>
                    <a
                      onClick={() => {
                        deletePhotoVideo(data, data?.actualProfilePhoto == true ? 1 : 0);
                        handleSettingDropDown();
                      }}
                    >
                      Delete
                    </a>
                  </li>
                ) : null}
              </ul>
            </span>
          </div>
        </div>
        <div className="video-text">
          <p className="checkbox-list">
            <span data-toggle="modal" data-target="#VideoPostIMGModal">
              {data?.actualProfilePhoto != true &&
              <>
                <button
                  className={"btn btn-orange"}
                  onClick={() => {
                    if (!data?.actualProfilePhoto) {
                      handleModal(data);
                    }
                  }}
                >
                  Share
                </button>
                <button 
                  className={"btn btn-blue"}
                  onClick={() => {
                    if (isVisible == 1 && data?.isprofileimage == 0) {
                      showTimelineClick(true, data)
                    } else {
                      swal({text: "Please make your photo / video as public to post again", icon: "warning"})
                    }
                  }}
                  disabled={data?.isprofileimage == 1 ? true : false}
                >
                  Repost
                </button>
              </>
              }
            </span>
          </p>
          <p className="checkbox-list">
            {data?.actualProfilePhoto != true &&
            <span data-toggle="modal" data-target="#VideoPostIMGModal">
              <input
                type="checkbox"
                checked={addProfile}
                onChange={(e) => addRemoveToProfile(e, data)}
                disabled={
                  data?.actualProfilePhoto ||
                  data.videophotosuploadedtype === "ProgramAndPricing"
                }
              />
              <label>Add in profile picture</label>
            </span>
            }
          </p>
        </div>
      </div>
    </li>
  );
};

const AddVideoPhoto = ({
  icon = PlusRoundIcon,
  text,
  onLinkModal,
  onFileUploadChnage,
  fileType,
}) => {
  return (
    <a className="link-box" onClick={onLinkModal}>
      <span className="link-inner-box">
        <span className="icon-box">
          <img src={icon} alt="icons" />
        </span>
        <span className="text">{text}</span>
      </span>
      {!onLinkModal &&
        (fileType === "both" ? (
          // Remove .flv, file extension
          <input
            className="browse-img"
            type="file"
            accept="video/*,.mkv,3g2,.3gp,.avi,.m4v,.mov,.mp4,.mpg,.mts,.m2ts,.mpeg,.wmv,image/png,image/jpeg, image.jpg"
            onChange={(e) => {
              onFileUploadChnage(e);
              e.currentTarget.value = null;
            }}
            multiple
          />
        ) : fileType === "video" ? (
          // Remove .flv, file extension
          <input
            className="browse-img"
            type="file"
            accept="video/*,.mkv,3g2,.3gp,.avi,.m4v,.mov,.mp4,.mpg,.mts,.m2ts,.mpeg,.wmv"
            onChange={(e) => {
              onFileUploadChnage(e);
              e.currentTarget.value = null;
            }}
            multiple
          />
        ) : fileType === "photo" ? (
          <input
            className="browse-img"
            type="file"
            accept="image/png,image/jpeg, image.jpg"
            onChange={(e) => {
              onFileUploadChnage(e);
              e.currentTarget.value = null;
            }}
            multiple
          />
        ) : null)}
    </a>
  );
};

const EditVideoPhotoOverlay = ({ open, onEditVideo, handleModal }) => {
  const [editInfo, setEditInfo] = useState(false);
  const onEditInfo = () => {
    setEditInfo(true);
  };
  return (
    <Dialog open={open}
            onClose={(event, reason)=> {
              if (reason == "backdropClick" || reason == "escapeKeyDown") {
                handleModal()
              }
            }}
    >
      <div
        className="modal fade common-slide-modal show"
        style={{ display: open ? "block" : "none" }}
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body modal-videophoto-slider ">
              <OwlCarousel className="owl-theme" loop margin={1} nav items="1">
                <div className="item">
                  <div className="video-detail-box">
                    <div className="img-box">
                      <img src={profileBg} alt="profileBg" />
                    </div>
                    <div className="detail-box">
                      <div className="video-share-box">
                        <button className="btn share-btn" onClick={handleModal}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="10.689"
                            height="11.803"
                            viewBox="0 0 10.689 11.803"
                          >
                            <path
                              d="M13.4,11.457a1.623,1.623,0,0,0-1.161.445L7.984,9.44a1.994,1.994,0,0,0,.06-.415,1.993,1.993,0,0,0-.06-.415l4.2-2.432a1.782,1.782,0,1,0-.566-1.3,1.982,1.982,0,0,0,.06.415L7.478,7.72a1.792,1.792,0,0,0-1.221-.474A1.763,1.763,0,0,0,4.5,9.025a1.793,1.793,0,0,0,3.007,1.3l4.228,2.461a1.488,1.488,0,0,0-.06.385,1.727,1.727,0,1,0,1.727-1.72Z"
                              transform="translate(-4.5 -3.094)"
                            ></path>
                          </svg>
                          Share
                        </button>
                        <button className="close" onClick={onEditVideo}>
                          <img src={closeGrayIcon} alt="" />
                        </button>
                      </div>
                      <div className="profile-info-box">
                        <div className="top-block">
                          <span>Photo</span>
                          <span
                            className="edit-button-toggle"
                            onClick={onEditInfo}
                          >
                            Edit
                          </span>
                        </div>
                        <div
                          className="profile-content"
                          style={{ display: editInfo ? "block" : "none" }}
                        >
                          <div className="form-group">
                            <select>
                              <option>Select an Album</option>
                              <option>Select an Album 1</option>
                              <option>Select an Album 2</option>
                            </select>
                          </div>
                          <div className="form-group">
                            <select>
                              <option>Select Tag</option>
                              <option>Select Tag 1</option>
                              <option>Select Tag 2</option>
                            </select>
                          </div>
                        </div>
                        <div className="button-box-info">
                          <button type="button" className="btn delete-button">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="9.677"
                              height="11.91"
                              viewBox="0 0 9.677 11.91"
                            >
                              <g transform="translate(-48)">
                                <path
                                  className="a"
                                  d="M56.746,1.489H54.7V1.117A1.117,1.117,0,0,0,53.583,0H52.094a1.117,1.117,0,0,0-1.117,1.117v.372H48.93a.93.93,0,0,0-.93.93v.744a.372.372,0,0,0,.372.372H57.3a.372.372,0,0,0,.372-.372V2.419A.93.93,0,0,0,56.746,1.489Zm-5.024-.372a.373.373,0,0,1,.372-.372h1.489a.373.373,0,0,1,.372.372v.372H51.722Z"
                                ></path>
                                <path
                                  className="a"
                                  d="M73.48,184a.116.116,0,0,0-.116.122l.307,6.444a1.115,1.115,0,0,0,1.115,1.064h5.652a1.115,1.115,0,0,0,1.115-1.064l.307-6.444a.116.116,0,0,0-.116-.122Zm5.621.93a.372.372,0,0,1,.744,0v4.838a.372.372,0,1,1-.744,0Zm-1.861,0a.372.372,0,0,1,.744,0v4.838a.372.372,0,1,1-.744,0Zm-1.861,0a.372.372,0,0,1,.744,0v4.838a.372.372,0,1,1-.744,0Z"
                                  transform="translate(-24.774 -179.72)"
                                ></path>
                              </g>
                            </svg>
                            Delete
                          </button>
                          <button
                            type="button"
                            className="btn green"
                            onClick={onEditVideo}
                          >
                            Save
                          </button>
                          <button
                            type="button"
                            className="btn"
                            onClick={onEditVideo}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="item">
                  <div className="video-detail-box">
                    <div className="img-box">
                      <img src={profileBg} alt="profileBg" />
                    </div>
                    <div className="detail-box">
                      <div className="video-share-box">
                        <button className="btn share-btn" onClick={handleModal}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="10.689"
                            height="11.803"
                            viewBox="0 0 10.689 11.803"
                          >
                            <path
                              d="M13.4,11.457a1.623,1.623,0,0,0-1.161.445L7.984,9.44a1.994,1.994,0,0,0,.06-.415,1.993,1.993,0,0,0-.06-.415l4.2-2.432a1.782,1.782,0,1,0-.566-1.3,1.982,1.982,0,0,0,.06.415L7.478,7.72a1.792,1.792,0,0,0-1.221-.474A1.763,1.763,0,0,0,4.5,9.025a1.793,1.793,0,0,0,3.007,1.3l4.228,2.461a1.488,1.488,0,0,0-.06.385,1.727,1.727,0,1,0,1.727-1.72Z"
                              transform="translate(-4.5 -3.094)"
                            ></path>
                          </svg>
                          Share
                        </button>
                        <button className="close" onClick={onEditVideo}>
                          <img src={closeGrayIcon} alt="" />
                        </button>
                      </div>
                      <div className="profile-info-box">
                        <div className="top-block">
                          <span>Photo</span>
                          <span
                            className="edit-button-toggle"
                            onClick={onEditInfo}
                          >
                            Edit
                          </span>
                        </div>
                        <div
                          className="profile-content"
                          style={{ display: editInfo ? "block" : "none" }}
                        >
                          <div className="form-group">
                            <select>
                              <option>Select an Album</option>
                              <option>Select an Album 1</option>
                              <option>Select an Album 2</option>
                            </select>
                          </div>
                          <div className="form-group">
                            <select>
                              <option>Select Tag</option>
                              <option>Select Tag 1</option>
                              <option>Select Tag 2</option>
                            </select>
                          </div>
                        </div>
                        <div className="button-box-info">
                          <button type="button" className="btn delete-button">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="9.677"
                              height="11.91"
                              viewBox="0 0 9.677 11.91"
                            >
                              <g transform="translate(-48)">
                                <path
                                  className="a"
                                  d="M56.746,1.489H54.7V1.117A1.117,1.117,0,0,0,53.583,0H52.094a1.117,1.117,0,0,0-1.117,1.117v.372H48.93a.93.93,0,0,0-.93.93v.744a.372.372,0,0,0,.372.372H57.3a.372.372,0,0,0,.372-.372V2.419A.93.93,0,0,0,56.746,1.489Zm-5.024-.372a.373.373,0,0,1,.372-.372h1.489a.373.373,0,0,1,.372.372v.372H51.722Z"
                                ></path>
                                <path
                                  className="a"
                                  d="M73.48,184a.116.116,0,0,0-.116.122l.307,6.444a1.115,1.115,0,0,0,1.115,1.064h5.652a1.115,1.115,0,0,0,1.115-1.064l.307-6.444a.116.116,0,0,0-.116-.122Zm5.621.93a.372.372,0,0,1,.744,0v4.838a.372.372,0,1,1-.744,0Zm-1.861,0a.372.372,0,0,1,.744,0v4.838a.372.372,0,1,1-.744,0Zm-1.861,0a.372.372,0,0,1,.744,0v4.838a.372.372,0,1,1-.744,0Z"
                                  transform="translate(-24.774 -179.72)"
                                ></path>
                              </g>
                            </svg>
                            Delete
                          </button>
                          <button
                            type="button"
                            className="btn green"
                            onClick={onEditVideo}
                          >
                            Save
                          </button>
                          <button
                            type="button"
                            className="btn"
                            onClick={onEditVideo}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </OwlCarousel>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

const mapStateToProps = (state) => {
  return {
    allAlbumsTags: state.athlete.editUserProfileData.albumTags,
    deleteAlbumTag: state.athlete.editUserProfileData.deleteAlbumTag,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    albumTagsListStart: (data) => dispatch(allAlbumTagsListStart(data)),
    deleteAlbumStart: (data) => dispatch(deleteAlbumStart(data)),
    deleteTagStart: (data) => dispatch(deleteTagStart(data)),
    allVideoPhotoListStart: (data) => dispatch(allVideoPhotoListStart(data)),
  };
};

SideBarVideo = connect(mapStateToProps, mapDispatchToProps)(SideBarVideo);
export {
  SubHeader,
  Title,
  LinkVideoOverlay,
  TimelinePostOverlay,
  SideBarVideo,
  VideoBox,
  PhotoBox,
  AddVideoPhoto,
  EditVideoPhotoOverlay,
  VideoOverlay,
};
export const getPostId = (data) =>{
  const finalArr = []
  data?.useracivityUploadedphotosandvideosid?.Useracivities?.length > 0 &&
  data?.useracivityUploadedphotosandvideosid?.Useracivities.map(el =>{if(!!el?.postid)finalArr.push(el?.postid)})
      // : finalArr?.push(data?.videoPostId ?? 0)
  return finalArr
}